module.exports = __webpack_public_path__ + "img/baas_36.74ccc251.png";